import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AdhesionFooterComponent } from './adhesion-footer.component'

@NgModule({
  declarations: [AdhesionFooterComponent],
  imports: [CommonModule],
  exports: [AdhesionFooterComponent]
})
export class AdhesionFooterModule {}
